"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useProductTerminalNodeHandler = void 0;
const react_1 = require("react");
const use_get_products_terminal_node_hook_1 = require("./use-get-products-terminal-node.hook");
const product_tree_nodes_1 = require("../../product-tree-nodes");
const useProductTerminalNodeHandler = () => {
    const { executeQuery } = (0, use_get_products_terminal_node_hook_1.useGetProductsTerminalNode)();
    const getProductTerminalNode = (0, react_1.useCallback)((productId) => (executeQuery(productId).then((res) => {
        var _a, _b;
        const { data } = res;
        const presentationEdges = (_b = (_a = data.products.edges[0]) === null || _a === void 0 ? void 0 : _a.node.presentations.edges) !== null && _b !== void 0 ? _b : [];
        const nodeIds = presentationEdges
            .map((e) => { var _a, _b; return (_b = (_a = e === null || e === void 0 ? void 0 : e.node) === null || _a === void 0 ? void 0 : _a.productTreeNode) === null || _b === void 0 ? void 0 : _b.id; })
            .filter((id) => Boolean(id));
        const fullPath = (0, product_tree_nodes_1.buildTreeNodePath)(nodeIds);
        return { fullPath, nodeIds };
    })), [executeQuery]);
    return {
        getProductTerminalNode,
    };
};
exports.useProductTerminalNodeHandler = useProductTerminalNodeHandler;
